import Seo from "@/components/Seo";
import { Eyebrow } from "@/components/Type";

const COMPANY = "W8ED PRIVATE LIMITED";
const CIN = "U62099KA2026PTC227613";
const ADDRESS =
  "WeWork – 37 Cunningham, Cunningham Road, No. 37, Cunningham Cross Road, SRT Road, Vasanth Nagar, Bengaluru, Karnataka 560052, India";

const CONTENT = {
  privacy: {
    title: "PRIVACY POLICY",
    description: "Privacy policy for W8ED PRIVATE LIMITED.",
    sections: [
      {
        h: "WHAT WE COLLECT",
        p: "When you join the W8LIST we collect your name and email address, and optionally your phone number. When you contact us we collect the details you submit through the form — name, email, optional phone and company, and your message.",
      },
      {
        h: "HOW WE USE IT",
        p: "We use this information to contact you about W8ED — what we are building, and replies to messages you send us. Nothing more.",
      },
      {
        h: "WHAT WE NEVER DO",
        p: "We do not sell your data. We do not share it with advertisers. We do not use it for anything unrelated to W8ED.",
      },
      {
        h: "STORAGE & SECURITY",
        p: "Your information is stored in secured systems with access restricted to W8ED. Email is delivered through reputable email infrastructure providers.",
      },
      {
        h: "YOUR RIGHTS",
        p: "You can ask to see, correct or delete your information at any time by emailing support@w8ed.com.",
      },
      {
        h: "CONTACT",
        p: `${COMPANY} (CIN: ${CIN}), ${ADDRESS}. Email: support@w8ed.com. Phone: 7483549690.`,
      },
    ],
  },
  terms: {
    title: "TERMS OF USE",
    description: "Terms of use for the W8ED website.",
    sections: [
      {
        h: "THE SITE",
        p: "This website is operated by W8ED PRIVATE LIMITED. By using it you accept these terms. The site presents the W8ED brand, editorial content and early access to what we are building.",
      },
      {
        h: "STATUS LABELS",
        p: "Some programmes, products and technologies shown on this site are marked CONCEPT, IN DEVELOPMENT or COMING SOON. These are not available for purchase or enrolment, and no availability is implied or guaranteed.",
      },
      {
        h: "INTELLECTUAL PROPERTY",
        p: "The W8ED name, mark, and all content on this site belong to W8ED PRIVATE LIMITED. Do not reproduce them without written permission.",
      },
      {
        h: "NO MEDICAL ADVICE",
        p: "Content on this site is educational and evidence-informed. It is not medical advice. See our Disclaimer for details.",
      },
      {
        h: "LIABILITY",
        p: "The site is provided as is. To the extent permitted by law, W8ED PRIVATE LIMITED is not liable for decisions made based on general educational content on this site.",
      },
      {
        h: "GOVERNING LAW",
        p: "These terms are governed by the laws of India, with jurisdiction in Bengaluru, Karnataka.",
      },
      {
        h: "CONTACT",
        p: `${COMPANY} (CIN: ${CIN}), ${ADDRESS}. Email: support@w8ed.com.`,
      },
    ],
  },
  disclaimer: {
    title: "DISCLAIMER",
    description: "W8ED content is educational and evidence-informed — not medical advice.",
    sections: [
      {
        h: "NOT MEDICAL ADVICE",
        p: "W8ED publishes educational, evidence-informed content about human health. Nothing on this website is a substitute for professional medical diagnosis, treatment or medical advice.",
      },
      {
        h: "NO DOCTOR–PATIENT RELATIONSHIP",
        p: "Using this website, joining the W8LIST, or reading W8ED content does not create a doctor–patient or provider–patient relationship of any kind.",
      },
      {
        h: "CONSULT A PROFESSIONAL",
        p: "Always consult a qualified healthcare professional before changing your diet, exercise, sleep or health routines — especially if you have a medical condition, are pregnant, or take medication.",
      },
      {
        h: "NO GUARANTEED OUTCOMES",
        p: "Health outcomes depend on individual context. W8ED does not guarantee any specific result from its content, programmes or future products.",
      },
      {
        h: "FORWARD-LOOKING CONTENT",
        p: "Items marked CONCEPT, IN DEVELOPMENT or COMING SOON describe work in progress. They are not available products or services, and descriptions may change before release.",
      },
      {
        h: "CONTACT",
        p: `${COMPANY} (CIN: ${CIN}), ${ADDRESS}. Email: support@w8ed.com.`,
      },
    ],
  },
};

export default function LegalPage({ kind }) {
  const doc = CONTENT[kind] || CONTENT.privacy;

  return (
    <article className="px-6 pb-32 pt-32 sm:pt-40">
      <Seo title={`${doc.title} | W8ED`} description={doc.description} path={`/${kind}`} />
      <div className="mx-auto max-w-3xl">
        <Eyebrow>Legal</Eyebrow>
        <h1 className="mt-8 font-display text-4xl font-extrabold tracking-tight text-[#f5f2ea] sm:text-5xl">
          {doc.title}
        </h1>
        <p className="mt-4 font-mono text-[10px] tracking-[0.25em] text-[#57534a]">
          EFFECTIVE 2026 — W8ED PRIVATE LIMITED
        </p>
        <div className="mt-14 space-y-10">
          {doc.sections.map((s) => (
            <section key={s.h}>
              <h2 className="font-mono text-[10px] tracking-[0.3em] text-[#C9A227]">{s.h}</h2>
              <p className="mt-3 text-sm leading-relaxed text-[#8e8a80]">{s.p}</p>
            </section>
          ))}
        </div>
      </div>
    </article>
  );
}
